import * as React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import MapLeaflet from "./Map/Map";
import MapLayers from "./Map/MapLayers";
import MapPointControls from "./Map/MapPointControls";
import { LayerMarkers, layers, LayerType, PolyLine } from "./data/layers";
import { fetchMarkers } from "./services/overpass";
import { BIKE_WAY_FILTER_OPTIONS, BIKE_WAY_LOADING_DEFAULTS, fetchWays } from './services/bicycle_ways';
import styled from "styled-components";
import L from "leaflet";
import { LayerProvider } from "./Map/LayerContext";




const AllContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  &:nth-child(2) {
    order: 0;
    flex: 1 0 auto;
    align-self: auto;
  }
`;

const MapShell = styled.div`
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
`;


export default function App() {
  const [activeMarkers, setActiveMarkers] = React.useState<LayerMarkers[]>([]);
  const [activeWays, setActiveWays] = React.useState<PolyLine[]>([])
  const [activeRoutes, setActiveRoutes] = React.useState<(any|PolyLine)[]>([])
  const [mapBounds, setBounds] = React.useState(""); //???
  const [mapInstance, setMapInstance] = React.useState<L.Map | null>(null);
  const [bikeWayVisibility, setBikeWayVisibility] = React.useState<Record<string, boolean>>(
    () => BIKE_WAY_FILTER_OPTIONS.reduce<Record<string, boolean>>((result, option) => {
      result[option.id] = true;
      return result;
    }, {})
  );
  const [bikeWayLoading, setBikeWayLoading] = React.useState<Record<string, boolean>>(
    BIKE_WAY_LOADING_DEFAULTS
  );

  /**React.useEffect(() => {
    // TODO research POI ?
  }, [activeLayers, mapBounds])*/

  // const innitLayer = () => {

  // }

  const lcRef = React.useRef<L.Control>();
  // Toggle a layer on the map
  const toggleLayer = (key: any) => {
    const activeLayer = activeMarkers.find((layer) => layer.key === key);
    //TODO: wyłączone chwilowo bo cą dwie warstwy - drogi i markery 
    if (activeLayer) {
      // Layer was found: remove its markers
      setActiveMarkers(
        activeMarkers.filter((layerMarkers) => layerMarkers.key !== key)
      );
      // Remove layer from the active layers
      return Promise.resolve();
    } else {
      // Layer not active yet
      const newLayer = layers.find((layer) => layer.key === key);
      if (newLayer && newLayer.type === LayerType.MARKER) {
          return fetchMarkers(newLayer.query, mapBounds).then((elems) => {
            if (typeof elems !== "boolean") {
              //TODO: zmien filtry na poczatek tylko node a potem dodawaj tags amenity
              //TODO: tags higway itp - i sprawdz literowki
              const newMarkers: LayerMarkers = {
                key,
                icon: newLayer.icon,
                markers: elems
                .filter((elem) => elem.tags?.amenity === key)
                  .map((elem) => ({
                    lat: elem.lat,
                    lon: elem.lon,
                    name: elem.tags?.name
                  }))
                  // .filter((elem) => elem.lat && elem.lon)
                };
                // Add the markers
                setActiveMarkers([...activeMarkers, newMarkers]);
                return newMarkers.markers.length;
              }
            }
          );
      } else {
          return Promise.reject();
      }
    }
  };

  React.useEffect(() => {
    const activeLayer = layers.find((layer) => layer.key === 'bicycleways');
    setBikeWayLoading(
      BIKE_WAY_FILTER_OPTIONS.reduce<Record<string, boolean>>((result, option) => {
        result[option.id] = true;
        return result;
      }, {})
    );
    fetchWays(setActiveWays, setActiveRoutes, activeLayer, (loadedClasses) => {
      setBikeWayLoading((current) => {
        const nextState = { ...current };

        loadedClasses.forEach((bikeWayClass) => {
          nextState[bikeWayClass] = false;
        });

        return nextState;
      });
    })
      .finally(() => {
        setBikeWayLoading(BIKE_WAY_LOADING_DEFAULTS);
      });
  },[])

  const toggleBikeWayVisibility = React.useCallback((bikeWayClass: string) => {
    setBikeWayVisibility((current) => ({
      ...current,
      [bikeWayClass]: !current[bikeWayClass],
    }));
  }, []);

  return (
    <div className="App">
      {/* <h1>Sosnowiec Bike Map</h1> //TODO: fonty, napis, logo */} 
      <LayerProvider>
        <AllContainer>
          <MapShell>
            <MapLeaflet
              fullTitle="My marker"
              latitude={50.2713933}
              longitude={19.1598567}
              setBounds={(bounds: React.SetStateAction<string>) => setBounds(bounds)}
              activeMarkers={activeMarkers}
              activeWays={activeWays}
              activeRoutes={activeRoutes}
              bikeWayVisibility={bikeWayVisibility}
              control={lcRef}
              onMapReady={setMapInstance}
              />
            <MapPointControls map={mapInstance} />
          </MapShell>
          <MapLayers
            bikeWayLoading={bikeWayLoading}
            bikeWayVisibility={bikeWayVisibility}
            onToggleBikeWayVisibility={toggleBikeWayVisibility}
          />
        </AllContainer>
      </LayerProvider>
    </div>
  );
}
